import { useEffect } from 'react';

interface FetchOnScrollArgs {
    hasNextPage?: boolean;
    isLoading?: boolean;
    isFetching?: boolean;
    onCanFetch: () => void;
    elementId?: string;
    offset?: number;
}
export function useFetchOnScroll({
    hasNextPage,
    isLoading,
    isFetching,
    onCanFetch,
    elementId,
    offset = 500,
}: FetchOnScrollArgs) {
    useEffect(() => {
        const mainElement = elementId ? document.getElementById(elementId) : document.getElementsByTagName('main')?.[0];
        const checkScrolledDown = () => {
            if (!mainElement) return;
            if (hasNextPage && !isLoading && !isFetching) {
                if (window.innerHeight + window.scrollY >= mainElement.offsetHeight - offset) {
                    onCanFetch();
                }
            }
        };
        window.addEventListener('scroll', checkScrolledDown);
        return () => window.removeEventListener('scroll', checkScrolledDown);
    }, [onCanFetch, hasNextPage, isFetching, isLoading, elementId, offset]);
}
